import { z } from '@bonanza-social/toolkit/api';

export const BalanceTypeEnum = z.enum(['Bonus', 'Cash']);

export const UserBalanceSchema = z.object({
  type: BalanceTypeEnum,
  amount: z.number(),
});

export const UserBalancesSchema = z.object({
  playerId: z.number(),
  balances: z.array(UserBalanceSchema),
});

export const CoinBalanceSchema = z.object({
  playerId: z.number(),
  amount: z.number(),
});

export type BalanceType = z.infer<typeof BalanceTypeEnum>;
